import React from "react";
import ReactDOM from "react-dom";
import * as serviceWorker from "./serviceWorker";
import "bootstrap/dist/css/bootstrap.min.css";
import App from "./App";
import { HashRouter } from "react-router-dom";
import { ToastProvider, DefaultToastContainer } from "react-toast-notifications";
import "react-big-calendar/lib/css/react-big-calendar.css";

const ToastContainer = (props: any) => (
    <DefaultToastContainer
        className="toast-container"
        style={{ zIndex: 99999999999 }}
        {...props}
    />
);

ReactDOM.render(
    <React.StrictMode>
        <HashRouter>
            <ToastProvider
                components={{ ToastContainer }}
                autoDismissTimeout={3000}
                autoDismiss={true}
            >
                <App />
            </ToastProvider>
        </HashRouter>
    </React.StrictMode>,
    document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
